import {
  FETCH_TRIPS_INIT,
  FETCH_TRIPS_SUCCESS,
  FETCH_TRIPS_FAIL,
  FETCH_TRIPDETAILSBYID_SUCCESS,
  ADD_DOC_INIT,
  DELETE_DOC_INIT,
  FETCH_COMPLETEDLOADDATA_INIT,
  FETCH_COMPLETEDLOADDATA_SUCCESS,
  FETCH_COMPLETEDLOADDATA_FAIL
} from "./action";

const initialState = {
  processing: false,
  error: false,
  completeddocaddOn: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_TRIPS_INIT:
      return {
        ...state,
        processing: true,
      };

    case FETCH_TRIPS_SUCCESS:
      console.log(action.payload.rows);
      return {
        ...state,
        processing: false,
        fetchedTrips: action.payload.rows,
        fetchedTripsCount: action.payload.count,
      };

    case FETCH_TRIPS_FAIL:
      return {
        ...state,
        processing: false,
      };

    case FETCH_TRIPDETAILSBYID_SUCCESS:
      return {
        ...state,
        fetchedTripDetail: action.payload,
      };

    case ADD_DOC_INIT:
      return {
        ...state,
        completeddocaddOn: [...state.completeddocaddOn, action.value],
      };

    case DELETE_DOC_INIT:
      return {
        ...state,
        completeddocaddOn: action.value,
      };

      case FETCH_COMPLETEDLOADDATA_INIT:
        return{
          ...state,
          processing:true
        }

      case FETCH_COMPLETEDLOADDATA_SUCCESS:
        return {
          ...state,
          loadList:action.payload.rows,
          loadCount:action.payload.count,
          processing:false
        }

        case FETCH_COMPLETEDLOADDATA_FAIL:
          return{
            ...state,
            processing:false
          }
    default:
      return {
        ...state,
      };
  }
}
